<template>
  <section
    :class="{
      'section-builder-testimonial': true,
    }"
  >
    <GeneralTheme :theme="configuration">
      <Testimonial
        v-if="data"
        :testimonial-data="data"
        :images-to-the-right="props.testimonial?.imagesToTheRight"
        :animated="props.testimonial?.animated"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import Testimonial from './Testimonial.vue';
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import type { SectionBuilderTestimonial } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
const props = defineProps<SectionBuilderTestimonial>();

const { getResolvedTestimonial } = useRefsStore();

const data = await getResolvedTestimonial(props.testimonial?.testimonial?.reference?._ref);
</script>

<style></style>
